const angular = require('angular');
const app = angular.module('learn-services');
app.factory('Storage', ['$window', '$cookies', function($window, $cookies) {
    var self = this;
    /**
     * Storage control object
     */
    self.storage = {
      put: function(key, value) {
        if ($window.localStorage) {
          $window.localStorage[key] = angular.toJson(value);
        } else {
          $cookies.putObject(key, value);
        }
      },
      get: function(key) {
        if ($window.localStorage) {
          if ($window.localStorage[key] === undefined || $window.localStorage[key] === null) {
            return null;
          }
          return angular.fromJson($window.localStorage[key] || '{}');
        } else {
          return $cookies.getObject(key);
        }
      },
      remove: function(key) {
        if ($window.localStorage) {
          $window.localStorage.removeItem(key);
        } else {
          $cookies.remove(key);
        }
      }
    };
    return self.storage;
  }]);